module.exports = __webpack_public_path__ + "static/media/pajero-1982na.e7e219ce.webp";